
export const PREFIX              = '@'
export const ENTITY_LABEL        = 'SUGGESTION'
export const INSERT_ACTION_LABEL = 'insert-suggestion'
